import { createLogic } from "redux-logic";
import type { BuildAndBuyLogicType } from "../store";
import Debug from "../../../../../common-deprecated/Debug";
import { type InvalidateSpecsType, setSpecs, SPECS_INVALIDATE_SPECS } from "../actions/SpecActions";
import { loadTechSpecs } from "../../../../shared-logic/utils/techSpecUtils";
import { loadMassManagement } from "../../utils/settings/bnbSettingUtils";
import { finishMassManagementFetch } from "../actions/MassManagementActions";

// This was added to replace the deprecated fetchData implementation above.
// Looks like this could be improved as this has some overlap with massmanagement logic as well.
// Kept the code logic as is to avoid regressions.
const invalidateSpecsLogic = (createLogic as BuildAndBuyLogicType<InvalidateSpecsType>)({
    type: SPECS_INVALIDATE_SPECS,

    async process({ getState }, dispatch, done) {
        const state = getState();

        try {
            const specs = await loadTechSpecs(
                state.commonSettings,
                state.car,
                state.basket,
                state.items,
                state.utils.financeOption,
            );
            if (loadMassManagement(state.bnbSettings) && specs.massValidationSpecs) {
                const { exceedingKilogram, error } = specs.massValidationSpecs;
                dispatch(finishMassManagementFetch(exceedingKilogram, !!error));
            }

            dispatch(setSpecs(specs.techSpecs, specs.standardEquipment));
        } catch (e) {
            Debug.error("Failed to fetch data", e);
        }
        done();
    },
});

export default [invalidateSpecsLogic];
